<template>
  <table class="ui single line striped selectable table">
    <thead>
      <tr>
        <th></th>
        <th>{{ $t('studentSelectionColumnLastName') }}</th>
        <th>{{ $t('studentSelectionColumnFirstName') }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-if="!studentList || studentList.length == 0">
        <td></td>
        <td colspan="4">{{ $t('choiceSelectionNoStudents') }}</td>
      </tr>
      <student-table-row
        v-for="student in studentList"
        v-bind:student="student"
        v-bind:key="student.Id"
        v-bind:actions="actions"
        v-on:action="rowAction"
      />
    </tbody>
  </table>
</template>

<script>
import StudentTableRow from '@/components/students/StudentTableRow';

export default {
  name: 'StudentTable',
  computed: {
    studentList() {
      return this.students || null;
    },
  },
  components: { StudentTableRow },
  props: ['students', 'actions'],
  methods: {
    rowAction(action) {
      this.$emit('rowAction', action);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/students/StudentTable.vue